<div libHeatmap
     [coordinates]="coordinates"
     [max]="max"
     [config]="config"
     [ngStyle]="{'width': config.width+ 'px', 'height':config.height+ 'px'}"
     class="heatmap"
>
</div>
